export const MAX_FIELD_WIDTH = 300;
export const CHAR_WIDTH = 8.4;
